export function encodeBase32UpperCaseNoPadding(bytes: Uint8Array): string {
    return encodeBase32_internal(bytes, base32UpperCaseAlphabet, EncodingPadding.None);
}

export function encodeBase32(bytes: Uint8Array): string {
    return encodeBase32UpperCase(bytes);
}
export function encodeBase32UpperCase(bytes: Uint8Array): string {
    return encodeBase32_internal(bytes, base32UpperCaseAlphabet, EncodingPadding.Include);
}

export function encodeBase32LowerCaseNoPadding(bytes: Uint8Array): string {
    return encodeBase32_internal(bytes, base32LowerCaseAlphabet, EncodingPadding.None);
}

enum EncodingPadding {
    Include = 0,
    None
}

const base32UpperCaseAlphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567";
const base32LowerCaseAlphabet = "abcdefghijklmnopqrstuvwxyz234567";

function encodeBase32_internal(
    bytes: Uint8Array,
    alphabet: string,
    padding: EncodingPadding
): string {
    let result = "";
    for (let i = 0; i < bytes.byteLength; i += 5) {
        let buffer = BigInt(0);
        let bufferBitSize = 0;
        for (let j = 0; j < 5 && i + j < bytes.byteLength; j++) {
            buffer = (buffer << BigInt(8)) | BigInt(bytes[i + j] ?? 0);
            bufferBitSize += 8;
        }
        if (bufferBitSize % 5 !== 0) {
            buffer = buffer << BigInt(5 - (bufferBitSize % 5));
            bufferBitSize += 5 - (bufferBitSize % 5);
        }
        for (let j = 0; j < 8; j++) {
            if (bufferBitSize >= 5) {
                result += alphabet[Number((buffer >> BigInt(bufferBitSize - 5)) & BigInt(0x1f))];
                bufferBitSize -= 5;
            } else if (bufferBitSize > 0) {
                result += alphabet[Number((buffer << BigInt(6 - bufferBitSize)) & BigInt(0x3f))];
                bufferBitSize = 0;
            } else if (padding === EncodingPadding.Include) {
                result += "=";
            }
        }
    }
    return result;
}